import { render, staticRenderFns } from "./EquipmentReplacementRequest.vue?vue&type=template&id=3b1ea20f"
import script from "./EquipmentReplacementRequest.vue?vue&type=script&lang=js"
export * from "./EquipmentReplacementRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports